var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4621 17.0004C33.4621 16.4481 33.8996 16 34.4384 16C34.9781 16 35.4153 16.4481 35.4153 17.0004C35.4153 17.5531 34.9781 18.0002 34.4384 18.0002C33.8996 18.0002 33.4621 17.5531 33.4621 17.0004ZM36.2691 16.8181L38.2493 16.4552V24.2412H36.2691V16.8181ZM39.1614 16.8181V24.2412H41.1428V16.4552L39.1614 16.8181ZM33.4485 18.5464V24.2412H35.4296V18.5464H33.4485ZM29.5706 21.0375C29.5706 19.3648 30.5006 18.5233 32.331 18.4629C32.331 18.4629 32.6616 18.4499 32.8567 18.4924V20.157C31.6964 20.1979 31.5682 20.6271 31.5682 21.6282V24.2412H29.5706V21.0375ZM26.9563 18.5399L26.9462 18.5667L26.9462 18.5667C26.8753 18.7574 26.5525 19.6252 25.828 20.5225V16.4552L23.7835 16.8695V24.2412H25.828V21.9622C26.4201 22.872 26.7126 24.2412 26.7126 24.2412H29.161C28.919 23.2099 27.8596 21.3088 27.8596 21.3088C28.8108 20.0735 29.228 18.7579 29.2946 18.5399H26.9563ZM19.5247 18.7621C19.5247 19.2966 20.1047 19.3353 20.355 19.3518C22.1911 19.4779 23.2854 20.3984 23.2854 21.8147C23.2854 23.0643 22.3069 24.3247 20.124 24.3247C19.1119 24.3247 18.2483 24.2226 17.4824 24.0163V22.1974C17.9938 22.4129 18.8365 22.639 19.7046 22.639C20.4968 22.639 20.968 22.3706 20.968 21.9144C20.968 21.3641 20.3966 21.3282 20.1775 21.3145L20.1751 21.3143C17.6182 21.1359 17.3428 19.5868 17.3428 18.9291C17.3428 17.787 18.1341 16.4552 20.3674 16.4552C21.6629 16.4552 22.3612 16.6622 22.9627 16.8776L22.9929 16.887V18.6536L22.9704 18.6471C22.7289 18.5425 22.4453 18.4398 22.4453 18.4398C21.9357 18.2835 21.2231 18.1172 20.6723 18.1172C20.3591 18.1172 19.5247 18.1172 19.5247 18.7621Z",
    fill: "#862165"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#2F2B43",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrill);
export default __webpack_public_path__ + "static/media/skrill.49204bbfca908df7b4069d4fb07c2447.svg";
export { ForwardRef as ReactComponent };